export const EVENTS = {
    HEADER_BREADCRUMB: "LAYOUT.HEADER_BREADCRUMB",
};
